import type { DeviceSummary } from '@ghostscreen/contracts';
import { formatNumber, i18n } from '../../i18n';

function formatPlain(value: number, maximumFractionDigits = 0): string {
  return formatNumber(value, { useGrouping: false, maximumFractionDigits });
}

/** Compact ops line: Render · HDMI · orientation · refresh. */
export function formatDeviceDisplaySummary(device: DeviceSummary): string | null {
  const parts: string[] = [];

  if (device.renderWidthPx != null && device.renderHeightPx != null) {
    parts.push(
      i18n.t('displays:deviceSummary.render', {
        width: formatPlain(device.renderWidthPx),
        height: formatPlain(device.renderHeightPx),
      }),
    );
  }
  if (device.outputWidthPx != null && device.outputHeightPx != null) {
    parts.push(
      i18n.t('displays:deviceSummary.hdmi', {
        width: formatPlain(device.outputWidthPx),
        height: formatPlain(device.outputHeightPx),
      }),
    );
  }
  if (device.orientation) {
    parts.push(
      device.orientation === 'landscape'
        ? i18n.t('displays:deviceSummary.landscape')
        : i18n.t('displays:deviceSummary.portrait'),
    );
  }
  if (device.refreshRateHz != null) {
    parts.push(
      i18n.t('displays:deviceSummary.refreshRate', { value: formatPlain(device.refreshRateHz, 2) }),
    );
  }
  if (device.densityDpi != null) {
    parts.push(i18n.t('displays:deviceSummary.density', { value: formatPlain(device.densityDpi) }));
  }

  return parts.length > 0 ? parts.join(' · ') : null;
}
